<template>
  <v-container v-if="this.user != ''" class="my-0">
    <v-card dark class="mx-auto my-2">
      <v-card-title style="word-break: break-word"
        >{{ t("Favorites") }}<v-spacer></v-spacer>
        <v-btn icon @click="getDevicesByOwner"
          ><v-icon>mdi-refresh</v-icon></v-btn
        >
      </v-card-title>

      <v-row>
        <v-col v-for="(item, index) in devicesByOwner" :key="item.id" cols="12">
          <v-card
            color="blue-grey"
            dark
            class="mx-2 my-8"
            max-width="100%"
            tile
          >
            <v-card-title>{{ item.name }} </v-card-title>

            <v-row>
              <v-col
                xs="12"
                sm="6"
                md="6"
                lg="4"
                xl="3"
                v-for="favorite in favorites[index]"
                :key="favorite.id"
                cols="12"
              >
                <v-card width="90%" class="mx-auto">
                  <v-card-title style="word-break: break-word">{{
                    t(favorite.spCode, favorite.cn)
                  }}</v-card-title>
                  <v-card-subtitle>
                    {{ favorite.sn }}
                  </v-card-subtitle>
                  <v-card-subtitle class="py-0">
                    <!-- Bird Pic -->
                    <div v-if="favorite.window == 'image'">
                      <img
                        width="100%"
                        :src="
                          'https://haikubox-images.s3.amazonaws.com/' +
                          favorite.spCode +
                          '.jpeg'
                        "
                        onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                      />
                    </div>

                    <!-- Spectrogram -->
                    <div v-if="favorite.window == 'spec'">
                      <Plotly
                        :data="favorite.spectrogram"
                        :layout="plotlyLayout"
                        :display-mode-bar="false"
                      ></Plotly>
                      <v-row no-gutters>
                        <v-col cols="1">0</v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1">{{ favorite.audioDuration && favorite.audioDuration > 2 ? Math.round(favorite.audioDuration / 3) : '' }}</v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1">{{ favorite.audioDuration && favorite.audioDuration > 2 ? Math.round(favorite.audioDuration * 2 / 3) : '' }}</v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1" class="d-flex justify-end">{{ favorite.audioDuration ? favorite.audioDuration.toFixed(0) + 's' : '3s' }}</v-col>
                      </v-row>
                    </div></v-card-subtitle
                  >
                  <v-row
                    ><v-col cols="6">
                      <v-avatar
                        class="mx-4"
                        size="24"
                        v-tooltip.bottom-start="t('Image')"
                        @click="setWindowImage(favorite)"
                      >
                        <img
                          :width="$vuetify.breakpoint.xs ? '100%' : '320'"
                          :src="
                            'https://haikubox-images.s3.amazonaws.com/' +
                            favorite.spCode +
                            '.jpeg'
                          "
                          onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                        />
                      </v-avatar>
                      <v-btn
                        icon
                        v-tooltip.bottom-start="t('Spectrogram')"
                        @click="spectrogram(favorite)"
                      >
                        <v-icon alt="spectrogram">mdi-chart-bubble</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="goNativeActive == false"
                        fab
                        small
                        dark
                        v-tooltip.bottom-start="'Download'"
                        @click="download(favorite)"
                        ><v-icon alt="download">mdi-download</v-icon>
                      </v-btn>
                    </v-col></v-row
                  >

                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        class="mx-2"
                        @click="playFile(favorite.wav, favorite)"
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ t("Play") }}
                      </v-btn>

                      <v-btn
                        @click="
                          playFileEnhance(
                            favorite.currentWav['filename']
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ t("Enhance") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        class="mx-3 my-0 py-0"
                        :items="favorite.wavList"
                        v-model="favorite.currentWav"
                        item-text="listname"
                        item-value="filename"
                        @change="
                          playFile(favorite.currentWav['filename'], favorite)
                        "
                        return-object
                        single-line
                      ></v-select> </v-col
                  ></v-row>
                  <v-card-text>
                    <v-btn
                      text
                      v-if="isBat(favorite)"
                      @click="navigateTo('https://www.batcon.org/about-bats/bats-101/')"
                      color="light-blue"
                      >BCI</v-btn
                    >
                    <v-btn
                      v-if="!isBat(favorite) && item.lon < -30"
                      text
                      @click="navigateTo('https://www.allaboutbirds.org/guide/' +
                            replaceSpaces(favorite.cn))"
                      color="light-blue"
                      >{{ t("About") }}</v-btn
                    >
                    <v-btn
                      text
                      v-if="!isBat(favorite)"
                      @click="navigateTo('https://ebird.org/species/' + favorite.spCode)"
                      color="light-blue"
                      >eBird</v-btn
                    >
                    <v-btn text color="grey darken-1" @click="openDeleteDialog(favorite.id)">{{ t("Delete") }}</v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <!-- Delete confirmation dialog - outside of all loops -->
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ t("AreYouSure") }}</v-card-title>
        <v-card-text>{{t("DeleteFavWarning")}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="deleteFavorite(deleteItemId)"
          >Yes</v-btn>
          <v-btn color="red darken-1" text @click="clickNo()">No</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Bottom Navigation -->
    <v-bottom-navigation hide-on-scroll fixed horizontal dark height="60">
      <v-btn
        @click="
          $vuetify.goTo(0, {
            duration: 300,
            offset: 0,
            easing: 'easeInOutCubic',
          })
        "
      >
        <span>To Top</span>
        <v-icon alt="Go to top of page">mdi-pan-up</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-container>
</template>
  
  <script>
import { API, Storage } from "aws-amplify";
// import { Auth } from "aws-amplify";
import {
  haikuboxByOwner,
  favoriteHitBySerial,
  getDeviceState,
} from "../graphql/queries";
import { deleteFavoriteHit } from "../graphql/mutations";
import { Plotly } from "vue-plotly";
var moment = require("moment-timezone");
var hann = [
  0.0, 3.77965773e-5, 1.51180595e-4, 3.4013491e-4, 6.04630957e-4, 9.44628746e-4,
  1.36007687e-3, 1.85091253e-3, 2.41706151e-3, 3.05843822e-3, 3.77494569e-3,
  4.56647559e-3, 5.43290826e-3, 6.3741127e-3, 7.38994662e-3, 8.48025644e-3,
  9.64487731e-3, 1.08836332e-2, 1.21963367e-2, 1.35827895e-2, 1.50427819e-2,
  1.65760932e-2, 1.81824916e-2, 1.98617342e-2, 2.16135671e-2, 2.34377255e-2,
  2.53339336e-2, 2.73019047e-2, 2.93413412e-2, 3.1451935e-2, 3.36333667e-2,
  3.58853068e-2, 3.82074146e-2, 4.05993391e-2, 4.30607187e-2, 4.55911813e-2,
  4.81903443e-2, 5.08578147e-2, 5.35931893e-2, 5.63960544e-2, 5.92659864e-2,
  6.22025514e-2, 6.52053053e-2, 6.82737943e-2, 7.14075543e-2, 7.46061116e-2,
  7.78689827e-2, 8.11956742e-2, 8.45856832e-2, 8.80384971e-2, 9.1553594e-2,
  9.51304424e-2, 9.87685015e-2, 1.02467221e-1, 1.06226043e-1, 1.10044397e-1,
  1.13921708e-1, 1.17857388e-1, 1.21850843e-1, 1.25901469e-1, 1.30008654e-1,
  1.34171776e-1, 1.38390206e-1, 1.42663307e-1, 1.46990432e-1, 1.51370928e-1,
  1.55804131e-1, 1.60289372e-1, 1.64825973e-1, 1.69413247e-1, 1.74050502e-1,
  1.78737036e-1, 1.8347214e-1, 1.88255099e-1, 1.9308519e-1, 1.97961681e-1,
  2.02883837e-1, 2.07850913e-1, 2.12862158e-1, 2.17916814e-1, 2.23014117e-1,
  2.28153297e-1, 2.33333576e-1, 2.38554171e-1, 2.43814294e-1, 2.49113148e-1,
  2.54449933e-1, 2.59823842e-1, 2.65234062e-1, 2.70679775e-1, 2.76160159e-1,
  2.81674384e-1, 2.87221617e-1, 2.92801019e-1, 2.98411747e-1, 3.04052952e-1,
  3.09723782e-1, 3.15423378e-1, 3.21150881e-1, 3.26905422e-1, 3.32686134e-1,
  3.38492141e-1, 3.44322565e-1, 3.50176526e-1, 3.56053138e-1, 3.61951513e-1,
  3.6787076e-1, 3.73809982e-1, 3.79768282e-1, 3.8574476e-1, 3.91738511e-1,
  3.97748631e-1, 4.03774209e-1, 4.09814335e-1, 4.15868096e-1, 4.21934577e-1,
  4.2801286e-1, 4.34102027e-1, 4.40201156e-1, 4.46309327e-1, 4.52425614e-1,
  4.58549094e-1, 4.64678841e-1, 4.70813928e-1, 4.76953428e-1, 4.83096412e-1,
  4.89241951e-1, 4.95389117e-1, 5.0153698e-1, 5.07684611e-1, 5.1383108e-1,
  5.19975458e-1, 5.26116815e-1, 5.32254225e-1, 5.38386758e-1, 5.44513487e-1,
  5.50633486e-1, 5.56745831e-1, 5.62849596e-1, 5.68943859e-1, 5.75027699e-1,
  5.81100196e-1, 5.87160431e-1, 5.93207489e-1, 5.99240456e-1, 6.05258418e-1,
  6.11260467e-1, 6.17245695e-1, 6.23213197e-1, 6.2916207e-1, 6.35091417e-1,
  6.41000339e-1, 6.46887944e-1, 6.52753341e-1, 6.58595644e-1, 6.6441397e-1,
  6.70207439e-1, 6.75975174e-1, 6.81716305e-1, 6.87429962e-1, 6.93115283e-1,
  6.98771407e-1, 7.0439748e-1, 7.09992651e-1, 7.15556073e-1, 7.21086907e-1,
  7.26584315e-1, 7.32047467e-1, 7.37475536e-1, 7.42867702e-1, 7.4822315e-1,
  7.5354107e-1, 7.58820659e-1, 7.64061117e-1, 7.69261652e-1, 7.74421479e-1,
  7.79539817e-1, 7.84615893e-1, 7.89648938e-1, 7.94638193e-1, 7.99582902e-1,
  8.04482319e-1, 8.09335702e-1, 8.14142317e-1, 8.18901439e-1, 8.23612347e-1,
  8.28274329e-1, 8.32886681e-1, 8.37448705e-1, 8.41959711e-1, 8.46419017e-1,
  8.5082595e-1, 8.55179843e-1, 8.59480037e-1, 8.63725883e-1, 8.67916738e-1,
  8.7205197e-1, 8.76130952e-1, 8.80153069e-1, 8.84117711e-1, 8.88024281e-1,
  8.91872186e-1, 8.95660845e-1, 8.99389686e-1, 9.03058145e-1, 9.06665667e-1,
  9.10211707e-1, 9.13695728e-1, 9.17117204e-1, 9.20475618e-1, 9.23770461e-1,
  9.27001237e-1, 9.30167455e-1, 9.33268638e-1, 9.36304317e-1, 9.39274033e-1,
  9.42177336e-1, 9.45013788e-1, 9.4778296e-1, 9.50484434e-1, 9.531178e-1,
  9.55682662e-1, 9.5817863e-1, 9.60605328e-1, 9.62962389e-1, 9.65249456e-1,
  9.67466184e-1, 9.69612237e-1, 9.71687291e-1, 9.73691033e-1, 9.75623159e-1,
  9.77483377e-1, 9.79271407e-1, 9.80986977e-1, 9.82629829e-1, 9.84199713e-1,
  9.85696393e-1, 9.87119643e-1, 9.88469246e-1, 9.89745e-1, 9.90946711e-1,
  9.92074198e-1, 9.9312729e-1, 9.94105827e-1, 9.95009663e-1, 9.9583866e-1,
  9.96592693e-1, 9.97271648e-1, 9.97875422e-1, 9.98403924e-1, 9.98857075e-1,
  9.99234805e-1, 9.99537058e-1, 9.99763787e-1, 9.99914959e-1, 9.99990551e-1,
  9.99990551e-1, 9.99914959e-1, 9.99763787e-1, 9.99537058e-1, 9.99234805e-1,
  9.98857075e-1, 9.98403924e-1, 9.97875422e-1, 9.97271648e-1, 9.96592693e-1,
  9.9583866e-1, 9.95009663e-1, 9.94105827e-1, 9.9312729e-1, 9.92074198e-1,
  9.90946711e-1, 9.89745e-1, 9.88469246e-1, 9.87119643e-1, 9.85696393e-1,
  9.84199713e-1, 9.82629829e-1, 9.80986977e-1, 9.79271407e-1, 9.77483377e-1,
  9.75623159e-1, 9.73691033e-1, 9.71687291e-1, 9.69612237e-1, 9.67466184e-1,
  9.65249456e-1, 9.62962389e-1, 9.60605328e-1, 9.5817863e-1, 9.55682662e-1,
  9.531178e-1, 9.50484434e-1, 9.4778296e-1, 9.45013788e-1, 9.42177336e-1,
  9.39274033e-1, 9.36304317e-1, 9.33268638e-1, 9.30167455e-1, 9.27001237e-1,
  9.23770461e-1, 9.20475618e-1, 9.17117204e-1, 9.13695728e-1, 9.10211707e-1,
  9.06665667e-1, 9.03058145e-1, 8.99389686e-1, 8.95660845e-1, 8.91872186e-1,
  8.88024281e-1, 8.84117711e-1, 8.80153069e-1, 8.76130952e-1, 8.7205197e-1,
  8.67916738e-1, 8.63725883e-1, 8.59480037e-1, 8.55179843e-1, 8.5082595e-1,
  8.46419017e-1, 8.41959711e-1, 8.37448705e-1, 8.32886681e-1, 8.28274329e-1,
  8.23612347e-1, 8.18901439e-1, 8.14142317e-1, 8.09335702e-1, 8.04482319e-1,
  7.99582902e-1, 7.94638193e-1, 7.89648938e-1, 7.84615893e-1, 7.79539817e-1,
  7.74421479e-1, 7.69261652e-1, 7.64061117e-1, 7.58820659e-1, 7.5354107e-1,
  7.4822315e-1, 7.42867702e-1, 7.37475536e-1, 7.32047467e-1, 7.26584315e-1,
  7.21086907e-1, 7.15556073e-1, 7.09992651e-1, 7.0439748e-1, 6.98771407e-1,
  6.93115283e-1, 6.87429962e-1, 6.81716305e-1, 6.75975174e-1, 6.70207439e-1,
  6.6441397e-1, 6.58595644e-1, 6.52753341e-1, 6.46887944e-1, 6.41000339e-1,
  6.35091417e-1, 6.2916207e-1, 6.23213197e-1, 6.17245695e-1, 6.11260467e-1,
  6.05258418e-1, 5.99240456e-1, 5.93207489e-1, 5.87160431e-1, 5.81100196e-1,
  5.75027699e-1, 5.68943859e-1, 5.62849596e-1, 5.56745831e-1, 5.50633486e-1,
  5.44513487e-1, 5.38386758e-1, 5.32254225e-1, 5.26116815e-1, 5.19975458e-1,
  5.1383108e-1, 5.07684611e-1, 5.0153698e-1, 4.95389117e-1, 4.89241951e-1,
  4.83096412e-1, 4.76953428e-1, 4.70813928e-1, 4.64678841e-1, 4.58549094e-1,
  4.52425614e-1, 4.46309327e-1, 4.40201156e-1, 4.34102027e-1, 4.2801286e-1,
  4.21934577e-1, 4.15868096e-1, 4.09814335e-1, 4.03774209e-1, 3.97748631e-1,
  3.91738511e-1, 3.8574476e-1, 3.79768282e-1, 3.73809982e-1, 3.6787076e-1,
  3.61951513e-1, 3.56053138e-1, 3.50176526e-1, 3.44322565e-1, 3.38492141e-1,
  3.32686134e-1, 3.26905422e-1, 3.21150881e-1, 3.15423378e-1, 3.09723782e-1,
  3.04052952e-1, 2.98411747e-1, 2.92801019e-1, 2.87221617e-1, 2.81674384e-1,
  2.76160159e-1, 2.70679775e-1, 2.65234062e-1, 2.59823842e-1, 2.54449933e-1,
  2.49113148e-1, 2.43814294e-1, 2.38554171e-1, 2.33333576e-1, 2.28153297e-1,
  2.23014117e-1, 2.17916814e-1, 2.12862158e-1, 2.07850913e-1, 2.02883837e-1,
  1.97961681e-1, 1.9308519e-1, 1.88255099e-1, 1.8347214e-1, 1.78737036e-1,
  1.74050502e-1, 1.69413247e-1, 1.64825973e-1, 1.60289372e-1, 1.55804131e-1,
  1.51370928e-1, 1.46990432e-1, 1.42663307e-1, 1.38390206e-1, 1.34171776e-1,
  1.30008654e-1, 1.25901469e-1, 1.21850843e-1, 1.17857388e-1, 1.13921708e-1,
  1.10044397e-1, 1.06226043e-1, 1.02467221e-1, 9.87685015e-2, 9.51304424e-2,
  9.1553594e-2, 8.80384971e-2, 8.45856832e-2, 8.11956742e-2, 7.78689827e-2,
  7.46061116e-2, 7.14075543e-2, 6.82737943e-2, 6.52053053e-2, 6.22025514e-2,
  5.92659864e-2, 5.63960544e-2, 5.35931893e-2, 5.08578147e-2, 4.81903443e-2,
  4.55911813e-2, 4.30607187e-2, 4.05993391e-2, 3.82074146e-2, 3.58853068e-2,
  3.36333667e-2, 3.1451935e-2, 2.93413412e-2, 2.73019047e-2, 2.53339336e-2,
  2.34377255e-2, 2.16135671e-2, 1.98617342e-2, 1.81824916e-2, 1.65760932e-2,
  1.50427819e-2, 1.35827895e-2, 1.21963367e-2, 1.08836332e-2, 9.64487731e-3,
  8.48025644e-3, 7.38994662e-3, 6.3741127e-3, 5.43290826e-3, 4.56647559e-3,
  3.77494569e-3, 3.05843822e-3, 2.41706151e-3, 1.85091253e-3, 1.36007687e-3,
  9.44628746e-4, 6.04630957e-4, 3.4013491e-4, 1.51180595e-4, 3.77965773e-5, 0.0,
];
var fft = require("fft-js").fft,
  ifft = require("fft-js").ifft;
import { FFT } from "dsp.js";

// https://github.com/chrisguttandin/standardized-audio-context
import { AudioContext } from "standardized-audio-context";
import { unmute } from "../unmute.min.js";
let globalAudioContext = null;
let globalGainNode = null;

export default {
  name: "Settings",
  props: ["user", "email"],
  mounted() {
    // load favorites with delay because sometimes don't have user
    if (this.user == "") {
      console.log("no user....wait");
      setTimeout(async () => {
        await this.getDevicesByOwner();
      }, 2000);
    } else {
      this.getDevicesByOwner();
    }
    // get language from local storage or browser
    const haikuboxLanguage = localStorage.getItem("haikuboxLanguage");
    if (haikuboxLanguage != null) {
      this.setLanguage(haikuboxLanguage);
    } else {
      let browserLanguage = navigator.language || navigator.languages[0];
      let browserLang = browserLanguage.split("-")[0];
      // console.log("language", browserLang);
      this.setLanguage(browserLang);
    }
    if (navigator.userAgent.indexOf("gonative") > -1) {
      this.goNativeActive = true;
    }
  },
  components: {
    Plotly,
  },
  data() {
    return {
      dialog: false,
      deleteItemId: null,
      numFavorites: 0,
      devicesByOwner: {},
      favorites: [],
      currentTranslations: {},
      selectedLanguage: "en",
      playbackGain: 100,
      goNativeActive: false,
      fftLength: 512,
      halfLength: 256,
      audioContextCache: new Map(),
      lastEnhancedFile: "",
      lastEnhancedAudio: [],
      lastEnhancedContext: null,
      plotlyLayout: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4,
        },
        height: 240,
        hovermode: false,
      },
    };
  },
  methods: {
    setLanguage(lang) {
      // console.log(lang);
      if (
        (lang != "da") &
        (lang != "de") &
        (lang != "en") &
        (lang != "es") &
        (lang != "fi") &
        (lang != "fr") &
        (lang != "it") &
        (lang != "nl") &
        (lang != "no") &
        (lang != "pt") &
        (lang != "sv")
      ) {
        lang = "en";
      }
      this.loadTranslations(lang).then((translations) => {
        this.currentTranslations = translations;
      });
      this.selectedLanguage = lang;
    },
    loadTranslations(lang) {
      return fetch(`/I18N/${lang}.json`)
        .then((response) => response.json())
        .then((translations) => {
          return translations;
        });
    },
    t(key, cn) {
      return this.currentTranslations[key] || cn;
    },
    isBat(itemOrSpCode) {
      if (typeof itemOrSpCode === 'object' && itemOrSpCode !== null) {
        return itemOrSpCode.group === 'bat';
      }
      return itemOrSpCode === 'batbatbat';
    },
    navigateTo(url) {
      if(this.goNativeActive){
        window.location.href = 'gonative://window/open?url=' + url + '&mode=appbrowser';
      }
      else{
        window.open(url, '_blank');
      } 
    },
    async getDevicesByOwner() {
      if (this.user == "") {
        console.log("user not recoginized");
        return;
      }
      const devicesByOwner = await API.graphql({
        query: haikuboxByOwner,
        variables: { owner: this.user },
      });
      this.devicesByOwner = devicesByOwner.data.haikuboxByOwner.items;
      this.loadFavorites();
      // console.log("devices by owner:", this.devicesByOwner);
    },
    async loadFavorites() {
      // console.log("loadFavorites", this.devicesByOwner.length);
      this.favorites = [];

      for (var i = 0; i < this.devicesByOwner.length; i++) {
        var favoriteList = [];
        var speciesFavorite = [];
        var uniqueHits = [];
        var speciesDict = {};
        var counter = 0;
        var nextToken = null;
        // console.log(this.devicesByOwner[i].serial);
        // get timezone from deviceState
        const deviceState = await API.graphql({
          query: getDeviceState,
          variables: { id: this.devicesByOwner[i].serial },
        });
        var currentTimezone = deviceState.data.getDeviceState.timezone;

        // load favorites from owner serial
        do {
          const filterArg = {
            serial: this.devicesByOwner[i].serial,
            nextToken: nextToken,
          };
          const favorites = await API.graphql({
            query: favoriteHitBySerial,
            variables: filterArg,
            limit: 24,
          });
          favoriteList = favoriteList.concat(
            favorites.data.favoriteHitBySerial.items
          );
          nextToken = favorites.data.favoriteHitBySerial.nextToken;
          // console.log('loadFavorites', favoriteList, nextToken);
        } while (nextToken != null);
        favoriteList.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
        // console.log(favoriteList);
        // Group by species
        for (var j = 0; j < favoriteList.length; j++) {
          var listname = moment
            .utc(favoriteList[j].dt)
            .tz(currentTimezone)
            .locale(this.selectedLanguage)
            .format("MMM D Y h:mm:ss a");
          if (!speciesFavorite.includes(favoriteList[j].cn)) {
            speciesFavorite.push(favoriteList[j].cn);
            speciesDict[favoriteList[j].cn] = counter;
            uniqueHits.push(favoriteList[j]);
            uniqueHits[counter].window = "image";
            uniqueHits[counter].wavList = [
              {
                filename: favoriteList[j]["wav"],
                listname: listname,
              },
            ];
            uniqueHits[counter].currentWav = {
              filename: favoriteList[j]["wav"],
              listname: listname,
            };
            counter = counter + 1;
          } else {
            uniqueHits[speciesDict[favoriteList[j].cn]]["wavList"].push({
              filename: favoriteList[j]["wav"],
              listname: listname,
            });
          }
        }
        // console.log("uniqueHits", uniqueHits);
        this.favorites.push(uniqueHits);
      }

      // console.log("favorites", this.favorites);
    },
    async deleteFavorite(id) {
      // console.log('deleteFavorite', id);
      await API.graphql({
        query: deleteFavoriteHit,
        variables: { input: { id: id } },
      });
      this.loadFavorites();
      this.dialog = false;
      this.deleteItemId = null;
    },
    handleDialogInput(value) {
      this.dialog = value;
      if(!value){
        this.deleteItemId = null;
      }
    },
    openDeleteDialog(favoriteId) {
    this.deleteItemId = favoriteId;
    this.dialog = true;
  },
    clickNo(){
        this.dialog = false;
        this.deleteItemId = null;
    },
    initAudioContext() {
      if (globalAudioContext == null) {
        const isIOS = /iPhone|iPod|iPad/.test(navigator.userAgent);
        if (isIOS) {
          globalAudioContext = new AudioContext();
          // Note: audioContext, allowBackgroundPlayback, forceIOSBehavior
          unmute(globalAudioContext, false, false);
        } else {
          globalAudioContext = new AudioContext();
        }
        globalGainNode = globalAudioContext.createGain();
        globalGainNode.gain.value = this.playbackGain; // Set initial volume level
        globalGainNode.connect(globalAudioContext.destination);
      }
    },
    async getMatchingAudioContext(targetSampleRate) {
      // Check cache first
      if (this.audioContextCache.has(targetSampleRate)) {
        return this.audioContextCache.get(targetSampleRate);
      }
      
      // Create new context with matching sample rate
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      const context = new AudioContext({ sampleRate: targetSampleRate });
      
      this.audioContextCache.set(targetSampleRate, context);
      return context;
    },

    async decodeAudioData(audioContext, arrayBuffer) {
      return new Promise((resolve, reject) => {
        audioContext.decodeAudioData(
          arrayBuffer,
          (decodedData) => resolve(decodedData),
          (error) => reject(error)
        );
      });
    },
    async playFile(audioFile, fav) {
      // console.log("playFile", cn);
      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;

      var audioUrl = await Storage.get(audioFile, { level: "private" });
      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();
      const audioBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);

      const sampleSource = globalAudioContext.createBufferSource();
      sampleSource.buffer = audioBuffer;
      sampleSource.connect(globalGainNode);
      sampleSource.start(0);
      if (fav.window == "spec") {
        this.spectrogram(fav);
      }
    },
    async playFileEnhance(audioFile) {
      this.initAudioContext();
      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      try {
        // Get audio URL and fetch
        const audioUrl = await Storage.get(audioFile, { level: "private" });
        const response = await fetch(audioUrl);
        const arrayBuffer = await response.arrayBuffer();

        // Detect the native sample rate
        let detectedSampleRate = await this.detectFlacSampleRate(arrayBuffer);

        // Get or create matching audio context
        const audioContext = await this.getMatchingAudioContext(detectedSampleRate || 44100);

        // Check if playing last file again (after we have the correct context)
        // Use audioFile as the key since favorite.id stays the same even when wav changes
        if (this.lastEnhancedFile === audioFile && this.lastEnhancedContext === audioContext) {
          // Create an AudioBufferSourceNode
          const sourceNode = audioContext.createBufferSource();
          sourceNode.buffer = this.lastEnhancedAudio;
          // Connect the source node to the AudioContext's destination (speakers)
          sourceNode.connect(audioContext.destination);
          // Start playback
          sourceNode.start();
          return;
        }

        const sample = await this.decodeAudioData(audioContext, arrayBuffer.slice(0));

        let signal = sample.getChannelData(0);

        // Define STFT parameters
        const fftSize = 512;
        const overlap = 256;
        const hopSize = fftSize - overlap;

        // Compute the STFT
        const stft = [];
        var meanMag = new Array(fftSize).fill(0);
        var stdMag = new Array(fftSize).fill(0);
        var numStrides = 0;

        for (let i = 0; i < signal.length - fftSize; i += hopSize) {
          const frame = signal.slice(i, i + fftSize);
          // Hanning Window
          for (var k = 0; k < fftSize; k++) {
            frame[k] = frame[k] * hann[k];
          }
          var phasors = fft(frame);
          // store running sum of magnitude to calculate mean
          for (var j = 0; j < phasors.length; j++) {
            meanMag[j] += Math.sqrt(
              phasors[j][0] * phasors[j][0] + phasors[j][1] * phasors[j][1]
            );
          }
          numStrides++;
          stft.push([...phasors]);
        }

        for (let j = 0; j < fftSize; j++) {
          meanMag[j] = meanMag[j] / numStrides;
        }

        // calculate SD
        for (let i = 0; i < stft.length; i++) {
          for (let j = 0; j < fftSize; j++) {
            let magnitude =
              Math.sqrt(
                stft[i][j][0] * stft[i][j][0] + stft[i][j][1] * stft[i][j][1]
              ) - meanMag[j];
            stdMag[j] += magnitude * magnitude;
          }
        }
        for (j = 0; j < fftSize; j++) {
          stdMag[j] = Math.sqrt(stdMag[j] / numStrides);
        }

        // gate values based on mean + 2*SD
        for (let i = 0; i < stft.length - 4; i++) {
          for (let j = 0; j < fftSize; j++) {
            // get average magnitude over 5 time slices
            let magnitude =
              (Math.sqrt(
                stft[i][j][0] * stft[i][j][0] +
                  stft[i][j][1] * stft[i][j][1]
              ) +
                Math.sqrt(
                  stft[i + 1][j][0] * stft[i + 1][j][0] +
                    stft[i + 1][j][1] * stft[i + 1][j][1]
                ) +
                Math.sqrt(
                  stft[i + 2][j][0] * stft[i + 2][j][0] +
                    stft[i + 2][j][1] * stft[i + 2][j][1]
                ) +
                Math.sqrt(
                  stft[i + 3][j][0] * stft[i + 3][j][0] +
                    stft[i + 3][j][1] * stft[i + 3][j][1]
                ) +
                Math.sqrt(
                  stft[i + 4][j][0] * stft[i + 4][j][0] +
                    stft[i + 4][j][1] * stft[i + 4][j][1]
                )) /
              5;
            if (magnitude < meanMag[j] + 1.9 * stdMag[j]) {
              stft[i][j][0] = stft[i][j][0] * 0.2;
              stft[i][j][1] = stft[i][j][1] * 0.2;
              // also flip mirror
              stft[i][fftSize - 1 - j][0] = stft[i][fftSize - 1 - j][0] * 0.2;
              stft[i][fftSize - 1 - j][1] = stft[i][fftSize - 1 - j][1] * 0.2;
            }
            if (j < 4) {
              stft[i][j][0] = stft[i][j][0] * 0.2;
              stft[i][j][1] = stft[i][j][1] * 0.2;
              // also flip mirror
              stft[i][fftSize - 1 - j][0] = stft[i][fftSize - 1 - j][0] * 0.2;
              stft[i][fftSize - 1 - j][1] = stft[i][fftSize - 1 - j][1] * 0.2;
            }
          }
        }

        // Compute the ISTFT
        let recoveredSignal = new Array(signal.length).fill(0);
        let recoveredSignalComplex = new Array(fftSize);
        for (let i = 0; i < stft.length - 4; i++) {
          recoveredSignalComplex = ifft(stft[i]);
          for (let j = 0; j < fftSize; j++) {
            if (i * hopSize + j < signal.length) {
              // get real part
              recoveredSignal[i * hopSize + j] += recoveredSignalComplex[j][0];
            }
          }
        }

        // Normalize the signal
        var maxSignal = 0;
        for (let i = 0; i < recoveredSignal.length - 1000; i += 1000) {
          var tempMax = Math.max(...recoveredSignal.slice(i, i + 1000));
          if (tempMax > maxSignal) {
            maxSignal = tempMax;
          }
        }
        maxSignal = 0.9 / maxSignal;

        for (let i = 0; i < recoveredSignal.length; i++) {
          recoveredSignal[i] = recoveredSignal[i] * maxSignal;
        }

        // Apply cos² ramp to prevent clicks at start/end
        this.applyCos2Ramp(recoveredSignal, sample.sampleRate, 5);

        // Check if this is a 192 kHz file that needs pitch shifting
        const effectiveSampleRate = detectedSampleRate || sample.sampleRate;
        const is192k = effectiveSampleRate >= 176400; // 176.4 kHz or 192 kHz
        let outputSampleRate = sample.sampleRate;

        if (is192k) {
          // For 192 kHz files, pitch shift down by factor of 12
          // This makes 96 kHz content sound like 8 kHz (96000 / 12 = 8000)
          outputSampleRate = Math.round(sample.sampleRate / 12);
        }

        // Create an AudioBuffer from the audio data
        const audioBuffer = audioContext.createBuffer(
          1,
          recoveredSignal.length,
          outputSampleRate
        );
        const channelData = audioBuffer.getChannelData(0);
        for (let i = 0; i < recoveredSignal.length; i++) {
          channelData[i] = recoveredSignal[i];
        }

        // Create an AudioBufferSourceNode
        const sourceNode = audioContext.createBufferSource();
        sourceNode.buffer = audioBuffer;
        // Connect the source node to the AudioContext's destination (speakers)
        sourceNode.connect(audioContext.destination);
        // Start playback
        sourceNode.start();
        this.lastEnhancedFile = audioFile;
        this.lastEnhancedAudio = audioBuffer;
        this.lastEnhancedContext = audioContext;
      } catch (error) {
        console.error('Error in playFileEnhance:', error);
      }
    },
    getEventText(dt) {
      let momentText = moment(dt).locale(this.selectedLanguage).fromNow();
      if (momentText == "in a few seconds") {
        momentText = "just now";
      }
      if (momentText == "a few seconds ago") {
        momentText = "just now";
      }
      return momentText;
    },

    applyCos2Ramp(signal, sampleRate, rampDurationMs = 5) {
      // Calculate ramp length in samples (default 5ms)
      const rampLength = Math.floor((rampDurationMs / 1000) * sampleRate);
      const effectiveRampLength = Math.min(rampLength, Math.floor(signal.length / 2));

      // Apply fade-in (cos² ramp at the beginning)
      for (let i = 0; i < effectiveRampLength; i++) {
        const angle = (Math.PI / 2) * (i / effectiveRampLength);
        const ramp = Math.sin(angle) * Math.sin(angle); // sin²(x) = cos²(π/2 - x)
        signal[i] *= ramp;
      }

      // Apply fade-out (cos² ramp at the end)
      for (let i = 0; i < effectiveRampLength; i++) {
        const idx = signal.length - 1 - i;
        const angle = (Math.PI / 2) * (i / effectiveRampLength);
        const ramp = Math.sin(angle) * Math.sin(angle);
        signal[idx] *= ramp;
      }

      return signal;
    },

    async detectFlacSampleRate(arrayBuffer) {
      try {
        const view = new DataView(arrayBuffer);

        // Check file signature
        const signature = String.fromCharCode(
          view.getUint8(0),
          view.getUint8(1),
          view.getUint8(2),
          view.getUint8(3)
        );

        // Handle WAV files (RIFF format)
        if (signature === 'RIFF') {
          // WAV file - sample rate is at bytes 24-27 (little-endian)
          const sampleRate = view.getUint32(24, true);
          return sampleRate;
        }

        // Handle FLAC files
        if (signature === 'fLaC') {
          // STREAMINFO block starts at byte 8
          // Sample rate is 20 bits starting at bit 80 (byte 18)
          const byte18 = view.getUint8(18);
          const byte19 = view.getUint8(19);
          const byte20 = view.getUint8(20);

          // Sample rate is 20 bits: all of byte18, all of byte19, top 4 bits of byte20
          const sampleRate = (byte18 << 12) | (byte19 << 4) | (byte20 >> 4);

          console.log('Extracted FLAC sample rate:', sampleRate);
          return sampleRate;
        }

        console.warn('Unknown audio file format, signature:', signature);
        return null;
      } catch (error) {
        console.error('Error detecting sample rate:', error);
        return null;
      }
    },

    spectrogram(fav) {
      //  console.log("Spectrogram", fav, audioFile);
      this.initAudioContext();

      let audioFile = fav.currentWav["filename"];
      Storage.get(audioFile, { level: "private" })
        .then(async (audioUrl) => {
          try {
            // Fetch the audio file
            const response = await fetch(audioUrl);
            const arrayBuffer = await response.arrayBuffer();
            
            // Detect the sample rate (WAV or FLAC)
            let detectedSampleRate = await this.detectSampleRate(arrayBuffer);
            // console.log('Detected sample rate:', detectedSampleRate || 'using context default');
            
            // Create matching context to avoid resampling
            const audioContext = await this.getMatchingAudioContext(detectedSampleRate || 44100);
            const audioBuffer = await this.decodeAudioData(audioContext, arrayBuffer.slice(0));
            // console.log('Decoded at:', audioBuffer.sampleRate, 'Hz (detected:', detectedSampleRate, 'Hz)');
            
            let signal = audioBuffer.getChannelData(0);
            const actualSampleRate = audioBuffer.sampleRate;
            
            // FFT parameters
            const fftLength = 512; // Fixed FFT length for simplicity
            const halfLength = fftLength / 2;
            const overlap = 0.5;
            const hopSize = Math.floor(fftLength * (1.0 - overlap));
            const numTimeSteps = Math.floor((signal.length - fftLength) / hopSize) + 1;
            
            // Control frequency cutoff (show 80% of spectrum)
            const frequencyCutoff = 0.8;
            let showLength = Math.floor(halfLength * frequencyCutoff);
            
            // Adjust for specific audio files if needed
            if (audioFile[5] == "2") {
              showLength = halfLength - Math.round(0.48 * halfLength);
            }
            
            const fft = new FFT(fftLength, actualSampleRate);
            
            // Generate spectrogram - store as 2D array
            const spectrogramData = [];
            const allValues = [];
            
            // Initialize the 2D array
            for (let i = 0; i < showLength; i++) {
              spectrogramData[i] = [];
            }
            
            // Process each time window
            for (let timeStep = 0; timeStep < numTimeSteps; timeStep++) {
              const startIdx = timeStep * hopSize;
              const chunk = signal.slice(startIdx, startIdx + fftLength);
              
              // Pad with zeros if needed
              while (chunk.length < fftLength) {
                chunk.push(0);
              }
              
              // Apply Hann window
              for (let i = 0; i < fftLength; i++) {
                chunk[i] = chunk[i] * hann[i];
              }
              
              // Perform FFT
              fft.forward(chunk);
              
              const scaleFactor = fftLength / 2;
              
              // Convert to dB and store
              for (let freqBin = 0; freqBin < showLength; freqBin++) {
                const value = fft.spectrum[freqBin] * scaleFactor;
                const db = 20 * Math.log10(Math.max(value, 1e-10));
                spectrogramData[freqBin][timeStep] = db;
                allValues.push(db);
              }
            }

            // Calculate percentiles for color scaling
            allValues.sort((a, b) => a - b);
            const percentile = (p) => {
              const index = Math.floor(allValues.length * p / 100);
              return allValues[Math.min(index, allValues.length - 1)];
            };
            
            const minVal = percentile(30);
            const maxVal = percentile(99);
            const dynamicRange = maxVal - minVal;
            
            // Clamp values
            for (let i = 0; i < showLength; i++) {
              for (let j = 0; j < numTimeSteps; j++) {
                spectrogramData[i][j] = Math.max(minVal, Math.min(maxVal, spectrogramData[i][j]));
              }
            }
            
            // Gaussian smoothing
            for (let i = 1; i < showLength - 1; i++) {
              for (let j = 1; j < numTimeSteps - 1; j++) {
                const smoothed = (
                  spectrogramData[i][j] * 0.4 +
                  (spectrogramData[i-1][j] + spectrogramData[i+1][j] + 
                  spectrogramData[i][j-1] + spectrogramData[i][j+1]) * 0.15
                );
                spectrogramData[i][j] = smoothed;
              }
            }

            // Improved colorscale
            const colorscale = [
              [0, "#440154"],      // Dark purple
              [0.3, "#3b528b"],    // Dark blue
              [0.7, "#21908c"],    // Teal
              [0.8, "#5dc863"],    // Green
              [0.9, "#fde725"],    // Yellow
              [1, "#ffffff"]       // White for peaks
            ];

            fav.spectrogram = [
              {
                z: spectrogramData,
                type: "heatmap",
                colorscale: colorscale,
                showscale: false,
                zmin: minVal,
                zmax: maxVal,
                zmid: minVal + dynamicRange * 0.9,
                zsmooth: 'best',
                connectgaps: false
              },
            ];

            // Store the actual duration for dynamic time scale
            fav.audioDuration = audioBuffer.duration;

            fav.window = "spec";
            fav.id += 1; // increment ID so that component updates
            
          } catch (err) {
            console.log(err);
            console.log("No audio", audioFile);
            return false;
          }
        })
        .catch((err) => {
          console.log("Error getting audio URL:", err);
        });
    },

    // Add this simpler sample rate detection method
    async detectSampleRate(arrayBuffer) {
      try {
        const view = new DataView(arrayBuffer);
        
        // Check file type by looking at magic bytes
        const firstFourBytes = String.fromCharCode(
          view.getUint8(0),
          view.getUint8(1), 
          view.getUint8(2),
          view.getUint8(3)
        );
        
        // WAV file detection
        if (firstFourBytes === 'RIFF') {
          // Sample rate is at bytes 24-27 (little-endian)
          const sampleRate = view.getUint32(24, true);
          // console.log('WAV file detected, sample rate:', sampleRate);
          return sampleRate;
        }
        
        // FLAC file detection
        if (firstFourBytes === 'fLaC') {
          // Look for STREAMINFO metadata block
          let offset = 4;
          
          while (offset < arrayBuffer.byteLength - 4) {
            const isLastBlock = (view.getUint8(offset) & 0x80) !== 0;
            const blockType = view.getUint8(offset) & 0x7F;
            const blockSize = (view.getUint8(offset + 1) << 16) | 
                            (view.getUint8(offset + 2) << 8) | 
                            view.getUint8(offset + 3);
            
            if (blockType === 0) { // STREAMINFO block
              const byte10 = view.getUint8(offset + 14);
              const byte11 = view.getUint8(offset + 15);
              const byte12 = view.getUint8(offset + 16);
              
              const sampleRate = (byte10 << 12) | (byte11 << 4) | (byte12 >> 4);
              // console.log('FLAC file detected, sample rate:', sampleRate);
              return sampleRate;
            }
            
            offset += 4 + blockSize;
            
            if (isLastBlock) break;
          }
        }
        
        return null;
        
      } catch (error) {
        console.error('Error detecting sample rate:', error);
        return null;
      }
    },

    setWindowImage(fav) {
      fav.window = "image";
      fav.id += 1;
    },
    async download(item) {
      // console.log(item);
      let audioFile = item.currentWav["filename"];
      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;

      var audioUrl = await Storage.get(audioFile, { level: "private" });
      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();
      const audioBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);
      let signal = audioBuffer.getChannelData(0);
      const max =
        1.5 * signal.reduce((acc, val) => Math.max(acc, val), -Infinity);
      const normalizedSignal = signal.map((value) => value / max);
      // console.log(audioBuffer);

      function saveArrayToWavFile(array, sampleRate, filename) {
        const numChannels = 1;
        const bitsPerSample = 16;
        const byteRate = (sampleRate * numChannels * bitsPerSample) / 8;
        const blockAlign = (numChannels * bitsPerSample) / 8;
        const dataSize = (array.length * bitsPerSample) / 8;
        const fileLength = 44 + dataSize;

        // Create a buffer for the WAV file
        const buffer = new ArrayBuffer(fileLength);
        const view = new DataView(buffer);

        // Write the WAV file header
        writeString(view, 0, "RIFF");
        view.setUint32(4, fileLength - 8, true);
        writeString(view, 8, "WAVE");
        writeString(view, 12, "fmt ");
        view.setUint32(16, 16, true);
        view.setUint16(20, 1, true);
        view.setUint16(22, numChannels, true);
        view.setUint32(24, sampleRate, true);
        view.setUint32(28, byteRate, true);
        view.setUint16(32, blockAlign, true);
        view.setUint16(34, bitsPerSample, true);
        writeString(view, 36, "data");
        view.setUint32(40, dataSize, true);

        // Write the sample data
        for (let i = 0; i < array.length; i++) {
          view.setInt16(44 + i * 2, array[i] * 32767, true);
        }

        // Convert the buffer to a Blob
        const blob = new Blob([buffer], { type: "audio/wav" });

        // Create a link element and trigger a download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      function writeString(view, offset, string) {
        for (let i = 0; i < string.length; i++) {
          view.setUint8(offset + i, string.charCodeAt(i));
        }
      }
      let filename =
        this.replaceSpaces(item.cn) +
        "_" +
        this.replaceSpaces(item.currentWav["listname"]) +
        ".wav";
      saveArrayToWavFile(normalizedSignal, audioBuffer.sampleRate, filename);
    },
    replaceSpaces(itemWithSpaces) {
      const itemWithUnderscores = itemWithSpaces.replace(/ /g, "_");
      const itemWithApostrophe = itemWithUnderscores.replace(/'/g, "");
      // // console.log("link", itemWithUnderscores);
      return itemWithApostrophe;
    },
  },
};
</script>
  